import { ItemView } from './common/CommonComponents';
import { useLanguage } from '../utils/LanguageContext';
import translations from './ComponentsTranslations.lang.json';
import { formatAsDollars, formatAsPercent } from './common/util.js';
import { EmploymentSetupStatus, PayrollElectionType } from '../shared/constants/employmentConstants.js';
import { Alert } from 'antd';

const PayrollElectionView = ({ employment }) => {
  const { lang, langForEnum } = useLanguage(translations);

  const { status } = employment;
  const { electionType, electionPercent, electionDollars } = employment.employeeRequestedPayrollElection ?? {};

  const items = [
    {
      field: 'electionType',
      value: langForEnum(PayrollElectionType, electionType),
    },
    { field: 'electionPercent', value: formatAsPercent(electionPercent) },
    { field: 'electionDollars', value: formatAsDollars(electionDollars) },
  ];

  return (
    <>
      {status === EmploymentSetupStatus.PENDING_ADMIN_PROCESSING && (
        <Alert description={lang('payrollEmployerAccountStatus')} type="warning" />
      )}
      {status === EmploymentSetupStatus.ACTIVE_EMPLOYMENT && (
        <Alert description={lang('activeEmployerAccountStatus')} type="success" />
      )}
      <ItemView items={items} />
    </>
  );
};

export default PayrollElectionView;
